import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData, TeamMember as TeamMemberType } from 'types'

const Team_3 = ({ title, paragraph, team, global_data }: RealEstateDataPageComponentData) => {
  const icons = global_data.pageConfig.design.icons
  const iconsStyle = icons === 'Solid' || icons === 'Light' ? `-${icons.toLowerCase()}` : ''

  const TeamMember = require(`../../teamMember/2`)?.default

  return (
    <section className="team-section c p-y-config">
      <Container fluid>
        <Row>
          <Col xs={12}>
            <h2 className="title mt-0 mb-4 text-center">{title}</h2>
          </Col>
          <Col xs={12}>
            <p className="paragraph text-center mb-4">{paragraph}</p>
          </Col>
          <Col
            xs={12}
            className="mt-5"
          >
            <Row className="justify-content-center grid-team">
              {team?.map((member: TeamMemberType, index: number) => (
                <div className="col-lg-4 col-md-6 col-12 mb-3 mb-lg-4">
                  <TeamMember
                    id={index}
                    key={index}
                    member={member}
                    skeleton={false}
                    iconsStyle={iconsStyle}
                  />
                </div>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default Team_3
